
import { PatternBackground } from "../patterns/PatternBackground";
import { PatternStyle } from "@/data/caseStudyTypes";

interface TestimonialSectionProps {
  testimonial: {
    quote: string;
    author: string;
    role?: string;  // Made optional to match actual usage
  };
  pattern: PatternStyle;
  id?: string;
}

export const TestimonialSection = ({ testimonial, pattern, id }: TestimonialSectionProps) => {
  return (
    <div className="relative overflow-hidden">
      {/* Abstract Background Pattern */}
      <PatternBackground pattern={pattern} id={id} />
      
      {/* Testimonial Content */}
      <div className="p-6 relative h-full flex flex-col justify-center">
        <div className="bg-white rounded-xl p-5 shadow-sm relative z-10">
          <p className="italic text-gray-600 mb-4">
            "{testimonial.quote}"
          </p>
          <div className="flex items-center">
            <div className="h-10 w-10 rounded-full bg-gray-200 flex-shrink-0"></div>
            <div className="ml-3">
              <p className="text-sm font-semibold text-gray-900">{testimonial.author}</p>
              {testimonial.role && (
                <p className="text-xs text-gray-500">{testimonial.role}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
